export default rawHtml

/** @ngInject */
function rawHtml($sce) {
    return (val) => $sce.trustAsHtml(val)
}



// WEBPACK FOOTER //
// ./src/services/rawHtml/filter.js